export default async (context) => {
    context.store.commit('loadReсentSearch');
    if (context.store.state.user?.restricted) {
        document.location.replace('https://old.triya.ru');
    }
}